export const messages = {
  en: {
    cart: {
      title: 'Shopping Cart',
      selectGoods: 'Select Goods',
      productInfo: 'Product Info',
      unitPrice: 'Unit Price (¥)',
      quantity: 'Quantity',
      subtotal: 'Subtotal (¥)',
      operation: 'Operation',
      selectedItems: 'Selected {num} items',
      totalPrice: 'Total: ¥{price}',
      checkout: 'Checkout',
      delete: 'Delete',
      inputValidNumber: 'Please enter a valid number',
      numberGreaterThanZero: 'Please enter a number greater than zero',
      minQuantity: 'Minimum quantity is 1',
      selectProductsFirst: 'Please select products first',
      sameStoreRequired: 'Products must be from the same store'
    }
  },
  zh: {
    cart: {
      title: '购物车',
      selectGoods: '选择商品',
      productInfo: '商品信息',
      unitPrice: '单价（元）',
      quantity: '数量',
      subtotal: '小计（元）',
      operation: '操作',
      selectedItems: '已选商品 {num} 件',
      totalPrice: '总价：¥{price}',
      checkout: '去结算',
      delete: '删除',
      inputValidNumber: '请输入有效数字',
      numberGreaterThanZero: '请输入大于零的数字',
      minQuantity: '不能在减少了，最小数量为1',
      selectProductsFirst: '请先选择商品',
      sameStoreRequired: '必须同店铺一起支付'
    }
  }
}